import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ValidationErrorListComponent } from './validation-error-list.component';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [ValidationErrorListComponent],
  imports: [TranslateModule, AsyncPipe, NgForOf, NgIf, SvgIconModule],
  exports: [ValidationErrorListComponent],
})
export class ValidationErrorListModule {}
